import { zodResolver } from "@hookform/resolvers/zod";
import { useMemo } from "react";
import { useForm } from "react-hook-form";

import type { GoogleFreeBookingLinksSettings } from "@/lib/gql/__generated__/graphql";

import { googleFreeBookingLinksSettingsHotelTypeInputZodSchema } from "./validation-schema";

import type { GoogleFreeBookingLinksSettingsHotelTypeZodSchemaType } from "./validation-schema";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	googleFreeBookingLinksSettings: GoogleFreeBookingLinksSettings;
};

export const useGoogleFreeBookingLinksSettingsHotelTypeForm = ({
	googleFreeBookingLinksSettings,
}: Props): { form: UseFormReturn<GoogleFreeBookingLinksSettingsHotelTypeZodSchemaType>; isNew: boolean } => {
	const isNew = useMemo(
		() => googleFreeBookingLinksSettings.createdAt === googleFreeBookingLinksSettings.updatedAt,
		[googleFreeBookingLinksSettings],
	);

	const form: UseFormReturn<GoogleFreeBookingLinksSettingsHotelTypeZodSchemaType> =
		useForm<GoogleFreeBookingLinksSettingsHotelTypeZodSchemaType>({
			mode: "onChange",
			resolver: zodResolver(googleFreeBookingLinksSettingsHotelTypeInputZodSchema),
			defaultValues: {
				hotelID: googleFreeBookingLinksSettings.hotelID,
				hotelType: isNew ? undefined : googleFreeBookingLinksSettings.hotelType, // ユーザーに選択させるために新規作成の場合はデフォルト値を設定しない
			},
		});

	return { form, isNew };
};

export { googleFreeBookingLinksSettingsHotelTypeInputZodSchema } from "./validation-schema";
export type {
	GoogleFreeBookingLinksSettingsHotelTypeZodSchemaType,
	GoogleFreeBookingLinksSettingsZodParseErrorType,
} from "./validation-schema";
